import GridContainer from "../../../Components/UiKits/Grid/GridContainer";

const Grid = () => {
  return <GridContainer />;
};

export default Grid;
